// ─── word.js ──────────────────────────────────────────────────────────────────
// Genereert Word-vriendelijke HTML (geen SVG).
// Wijzig hier bij aanpassingen aan Word/doc export.

import { fmtE, fmtKg, fmtK } from './helpers.js';
import { generateHTML } from './index.js';

function maandTabelWord(data, labels) {
  const max = Math.max(...data.filter(Boolean),1);
  return `<table style="width:100%;border-collapse:collapse;font-size:9pt;margin-bottom:12px;">
    <thead><tr style="background:#f7f6f2;">
      <th style="padding:5px 8px;text-align:left;font-weight:bold;color:#1a364c;border-bottom:2px solid #1a364c;">Maand</th>
      <th style="padding:5px 8px;text-align:right;font-weight:bold;color:#1a364c;border-bottom:2px solid #1a364c;">Kosten</th>
      <th style="padding:5px 8px;text-align:left;font-weight:bold;color:#1a364c;border-bottom:2px solid #1a364c;">Aandeel</th>
    </tr></thead>
    <tbody>${data.map((v,i)=>v>0?`<tr>
      <td style="padding:4px 8px;border-bottom:1px solid #f1f5f9;">${labels[i]}</td>
      <td style="padding:4px 8px;text-align:right;border-bottom:1px solid #f1f5f9;font-weight:bold;">${fmtE(v)}</td>
      <td style="padding:4px 8px;border-bottom:1px solid #f1f5f9;">
        <div style="display:inline-block;width:${Math.round((v/max)*120)}px;height:8px;background:#1a364c;vertical-align:middle;"></div>
        <span style="font-size:8pt;color:#64748b;margin-left:4px;">${Math.round((v/max)*100)}%</span>
      </td>
    </tr>`:'').join('')}
    </tbody>
  </table>`;
}

function rankingTabelWord(items, formatVal) {
  if(!items||items.length===0) return '<p style="color:#94a3b8;font-size:9pt;">Geen data</p>';
  const max = Math.max(...items.map(i=>i.v),1);
  const kleuren = ['#1a364c','#24496a','#2d5a7a','#4a7a9b','#7aaccf','#c2e6ef'];
  return `<table style="width:100%;border-collapse:collapse;font-size:9pt;">
    <tbody>${items.map((item,i)=>`<tr>
      <td style="padding:4px 6px;border-bottom:1px solid #f5f5f5;width:20px;">
        <div style="width:10px;height:10px;background:${kleuren[i]||'#1a364c'};display:inline-block;"></div>
      </td>
      <td style="padding:4px 6px;border-bottom:1px solid #f5f5f5;">${item.l}</td>
      <td style="padding:4px 6px;border-bottom:1px solid #f5f5f5;text-align:right;font-weight:bold;">${formatVal?formatVal(item.v):item.v}</td>
      <td style="padding:4px 6px;border-bottom:1px solid #f5f5f5;width:100px;">
        <div style="display:inline-block;width:${Math.round((item.v/max)*80)}px;height:6px;background:${kleuren[i]||'#1a364c'};vertical-align:middle;"></div>
      </td>
    </tr>`).join('')}
    </tbody>
  </table>`;
}

function generateWordHTML(type, aanvragen, facturen, bedrijfsnaam, cfg, logo) {
  // Word-specifieke versie: geen SVG, tabellen ipv grafieken, Word XML namespace
  const innerHtml = generateHTML(type, aanvragen, facturen, bedrijfsnaam, cfg, true, logo);
  // Vervang SVG elementen door placeholder tekst (Word kan geen SVG)
  const noSvg = innerHtml.replace(/<svg[\s\S]*?<\/svg>/gi, (match) => {
    // Haal data op uit de SVG (balken → tabel)
    return '<p style="color:#64748b;font-style:italic;font-size:9pt;">[Grafiek — zie live rapport voor visuele weergave]</p>';
  });
  return `<html xmlns:o="urn:schemas-microsoft-com:office:office"
               xmlns:w="urn:schemas-microsoft-com:office:word"
               xmlns="http://www.w3.org/TR/REC-html40">
  <head><meta charset="UTF-8">
    <style>
      body { font-family: Arial, sans-serif; font-size: 10pt; color: #1e293b; margin: 2cm; }
      table { width: 100%; border-collapse: collapse; font-size: 9pt; margin-bottom: 12pt; }
      th { background: #f7f6f2; padding: 5pt 7pt; font-weight: bold; color: #1a364c; font-size: 8pt; text-transform: uppercase; border-bottom: 1.5pt solid #1a364c; }
      td { padding: 4pt 7pt; border-bottom: 0.5pt solid #f1f5f9; }
      tr:nth-child(even) td { background: #fafafa; }
      h1,h2,h3 { color: #1a364c; }
      .badge { padding: 2pt 6pt; border-radius: 3pt; font-size: 8pt; font-weight: bold; }
    </style>
  </head>
  <body>${noSvg}</body>
  </html>`;
}

export { generateWordHTML };
